export const spacer = '1rem'
export const spacing0 = '0'
export const spacing1 = `calc(${spacer} * .25)`
export const spacing2 = `calc(${spacer} * .5)`
export const spacing3 = `calc(${spacer} * 1)`
export const spacing4 = `calc(${spacer} * 1.5)`
export const spacing5 = `calc(${spacer} * 3)`
export const maxWidthContainer = '1400px'
export const borderRadius = '12px'
export const boxShadow = '0 6px 12px 0px rgba(0,0,0,0.16)'
export const boxShadowInverse = '0 -6px 12px 0 rgba(0,0,0,0.16)'
export const backdropBlurFilter = 'saturate(180%) blur(5px)'